import { Button } from "@jmurga97/components";

import { printDocument } from "@lib/print-mode";

/** Opens the browser's print dialog, where "Save as PDF" is the destination people want. */
export function PrintButton() {
  return (
    <Button
      variant="secondary"
      size="sm"
      onClick={() => {
        void printDocument();
      }}
    >
      Download PDF
    </Button>
  );
}
